import { ButtonBase } from '@mui/material';
import './DefaultText.scss';

interface DefaultTextProps {
  title: string;
  price: string | React.ReactElement;
  onClick: () => void;
}

const DefaultText = ({ title, price, onClick }: DefaultTextProps) => {
  return (
    <ButtonBase className="dish dish__default-text" onClick={onClick}>
      <h3 className="dish__title">{title}</h3>
      <p className="dish__price">{price}</p>
    </ButtonBase>
  );
};

export default DefaultText;
